<template>
  <div>
    <v-container fluid class="pa-0">
      <!-- <material-card icon="mdi-clipboard-text" inline title="View Vehicle Details"> -->
      <v-card class="v-card--material pa-3 ma-2 rounded-lg " elevation="2">
        <v-row no-gutters>
          <v-col cols="12" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2 mx-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Student - Route Mapping - Vehicle Mapping
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-stepper class="routemappingshadow" v-model="step">
          <!-- Stepper Header -->
          <v-stepper-header class="routemappingheader">
            <p v-if="step === 1">Step 1: Route Mapping</p>
            <p v-else>Step 2: Vehicle Mapping</p>
            <v-btn color="primary" @click="gotToStep()" :disabled="routeAssignedTo === 0">Go to Step {{step === 1 ? "2 >>>" : " 1"}}</v-btn>
            <!-- <v-stepper-step :complete="step > 1" step="1">Step 1: Route Mapping</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2">Step 2: Vehicle Mapping</v-stepper-step> -->
          </v-stepper-header>

          <!-- Stepper Items -->
          <v-stepper-items>
            <!-- Step 1: Route Mapping -->
            <v-stepper-content class="routemappingcontainer" step="1">
              <v-row class="mb-3" justify="end">
                <v-col cols="4" v-if="!selected.length">Number of Students who Availed Transport: {{numberOfStudentsAvailedForTransport}}</v-col>
                <v-col cols="4" v-if="!selected.length">Route Assigned To: {{routeAssignedTo}}</v-col>
                <v-col cols="4" class="text-right marginauto" >
                  <v-row class="mt-2 text-red">Note**</v-row>
                  <v-row><strong> Pick up: </strong>  &nbsp; Home to School journey</v-row>
                  <v-row><strong> Drop: </strong> &nbsp; School to Home journey</v-row>
                </v-col>
              </v-row>
              <v-row >
                <v-col cols="3">
                  <v-radio-group class="radiobuttons" v-model="assignedFilter" @change="filterStudentsByAssigned">
                    <v-radio label="Assigned Students" value="assigned"></v-radio>
                    <v-radio label="Un-Assigned Students" value="unassigned"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="3"><v-text-field label="Search Student..." v-model="searchKey" @input="filterStudents" hide-details dense></v-text-field></v-col>
                <v-col cols="3"><v-btn class="mb-2" @click="clearFilters">Clear</v-btn></v-col>
                <v-col v-if="!globalCTA && isCurrentAcademicYearSelected" cols="3"  class="text-right"><v-btn class="mb-2 ml-auto" @click="assignRouteToAll" :disabled="assignRouteDisableBtn()">Assign Route to All</v-btn></v-col>
              </v-row>
              <div v-if="globalCTA"  class="d-flex justify-end mb-2 gap-1">
                <button class="button is-primary mr-2"  type="submit" @click="assigneRouteGlobal" :disabled="!validateForm()">
                  Save And Move to Vehicle Mapping
                </button>
                <button class="button is-danger"  type="button" @click="emptySelection" >
                  Cancel
                </button>
              </div>
                <v-data-table
                v-model="selected"
                :headers="headersStep1"
                :items="!searching ? studentsStep1 : studentsStep1Filtered"
                item-key="studentAdmissionID"
                class="elevation-1"
                @toggle-select-all="isCurrentAcademicYearSelected && assignRouteToAll('headerCheckbox')"
                :show-select="isCurrentAcademicYearSelected"
              >
                <template v-slot:item="{ item, isSelected, select, index }">
                  <tr >
                    <td @click="toggle(isSelected, select, item.srNo - 1)" v-if="isCurrentAcademicYearSelected">
                      <v-checkbox
                        v-model="isSelected"
                        class="pe-2"
                        @change="toggle(isSelected, select, item.srNo - 1)"
                      ></v-checkbox>
                    </td>
                    <td >{{item.srNo}}</td>
                    <td >
                      <v-chip style="margin-top: 5px;" variant="flat" color="primary" v-if="item.studentnewInstallment.some(i => i.flag === 'amber')">
                        <span>{{item.studentEnrollment.name}}</span>
                      </v-chip>
                      <v-chip style="margin-top: 5px;" variant="flat" color="red" v-else-if="item.studentnewInstallment.some(i => i.flag === 'red')">
                        <span>{{item.studentEnrollment.name}}</span>
                      </v-chip>
                      <span v-else>{{item.studentEnrollment.name}}</span>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="mx-2"
                          >
                            mdi-home
                          </v-icon>
                        </template>
                        <span>{{item.studentEnrollment.address}}</span>
                      </v-tooltip>
                      <p class="font-weight-thin">{{Array.from(new Set(item.studentEnrollment.enquiry.assignFeeInstallments.map(i => i.feeTypeName))).join(", ")}}</p>
                    </td>
                    <td>
                      <div v-if="isSelected">
                        <v-select
                          v-model="studentDestinationFormData[item.srNo - 1].journeyType"
                          :items="journeyTypes"
                          label="Select Journey Type"
                          dense
                          hide-details
                        ></v-select>
                      </div>
                      <div v-else>{{ item.transportStudentVehicleMapping && item.transportStudentVehicleMapping.journeyType ? item.transportStudentVehicleMapping.journeyType : "-" }}</div>
                    </td>
                    <td>
                      <div v-if="isSelected">
                        <label class=""> &nbsp;</label>
                        <v-autocomplete v-model="studentDestinationFormData[item.srNo - 1].destinationID" key="id" class="my-0 py-1" required single-line placeholder="---Select---" :items="destinations" item-text="destination" item-value="id">
                        </v-autocomplete>
                      </div>
                      <div v-else>{{ item.transportStudentVehicleMapping && item.transportStudentVehicleMapping.transportDestination ? item.transportStudentVehicleMapping.transportDestination.destination : "-" }}</div>
                    </td>
                    <td>
                      <div class="d-flex" v-if="isCurrentAcademicYearSelected">
                      <v-btn  class="mr-2" v-if="!globalCTA && isSelected && (item.transportStudentVehicleMapping || !item.transportStudentVehicleMapping)" @click="editRoute(select, item.srNo - 1, item)" small><v-icon color="success" >mdi-check-circle-outline</v-icon></v-btn>
                      <v-btn class="ml-2" v-if="!globalCTA && isSelected && (item.transportStudentVehicleMapping || !item.transportStudentVehicleMapping)" @click="removeSelection(select, item.srNo - 1, item)" small><v-icon color="red">mdi-close-circle-outline</v-icon></v-btn>
                      <v-btn v-if="!globalCTA && !isSelected && item.transportStudentVehicleMapping && (item.transportStudentVehicleMapping.journeyType || item.transportStudentVehicleMapping.destinationID)" small @click="addSelection(select)">Edit</v-btn>
                      <v-btn v-if="!globalCTA && !isSelected && (!item.transportStudentVehicleMapping || (item.transportStudentVehicleMapping && !item.transportStudentVehicleMapping.journeyType && !item.transportStudentVehicleMapping.destinationID))" small @click="addSelection(select)">Assign Route</v-btn>
                      <p v-if="globalCTA">-</p>
                      </div>
                      <div v-else>
                        <p >-</p>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <!-- <v-btn color="primary" @click="step = 2">Go to Step 2 >>> </v-btn> -->
            </v-stepper-content>

            <!-- Step 2: Vehicle Mapping -->
            <v-stepper-content class=" containerviewall" step="2">
              <v-row class="mb-3">
                <v-col cols="4" >Number of Students with Route: {{routeAssignedStudentCount}}</v-col>
                <v-col cols="4" v-if="!selected.length">Vehicle Assigned To: {{vehicleAssigneToCount}}</v-col>
                <v-col cols="4" v-if="studentsWithoutSeat > 0">Vehicle Assigned Pending for: {{ studentsWithoutSeat }}</v-col>
              </v-row>
              <v-row class="mb-3">
                <v-col cols="4">
                  <v-select
                    v-model="journeyType"
                    :items="journeyTypes.slice(0, 2)"
                    label="Select Journey Type"
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-btn @click="applyJourneyType">Apply</v-btn>
                <v-col cols="4" class="text-right marginauto">
                  <v-row class="mt-2 text-red">Note**</v-row>
                  <v-row><strong>Pick up: </strong> &nbsp; Home to School journey</v-row>
                  <v-row><strong>Drop: </strong> &nbsp; School to Home journey</v-row>
                </v-col>
              </v-row>
              <div class="d-flex justify-end mb-2" v-if="disableDraggable">
                <div class="me-auto">Student List for {{journeyTypeName}} Journey</div>
                <button v-if="isCurrentAcademicYearSelected" class="button is-primary mr-2 ml-auto"  type="button" @click="disableDraggable = false">
                  Rearrange Students
                </button>
                <button class="button is-secondary"  type="button" @click="downloadListData" >
                  Download List
                </button>
              </div>
              <div class="d-flex justify-end mb-2" v-else>
                <div>Student List for {{journeyTypeName}} Journey</div>
                <button v-if="isCurrentAcademicYearSelected" class="button is-primary mr-2 ml-auto"  type="button" @click="saveStudentSeatArrangements">
                  Save
                </button>
                <button v-if="isCurrentAcademicYearSelected" class="button is-danger"  type="button" @click="getStudentVehicleMappings(journeyType)" >
                  Cancel
                </button>
              </div>

              <template>
                <div class="flext-container">
                  <div class="grid-table tableheaderbg">
                    <div class="table-column"> </div>
                    <div class="table-column"></div>

                    <div v-for="(stop,index) in visibleVehicles" :key="stop.id" class="table-column">
                      <div class="arrow-row">
                        <div class="arrow left-arrow" v-if="index===0"
                          :class="{ disabled: currentFirstColumn === 0 }"
                          @click="slideLeft"
                        >
                          &#x276E;
                        </div>

                        <div class="arrow right-arrow" v-if="index===visibleColumns-1"
                            :class="{ disabled: currentFirstColumn + visibleColumns >= tableHeaders.length }"
                            @click="slideRight"
                          >
                            &#x276F;
                          </div>
                      </div>
                    </div>

                    <div class="table-column extra-column" v-if="glimpseVehicle.length">
                    </div>

                  </div>
                </div>
              </template>

              <template>
                <div class="flext-container">

                  <div class="grid-table tablebodyview">

                    <!-- Sr. No. Column -->
                    <div class="table-column">
                      <h3 class="header">Sr. No.</h3>
                      <div
                        v-for="(element, index) in Array.from({ length: maxCapacity }, (_, i) => i+1)"
                        :key="element"
                        class="table-cell"
                      >
                        {{ index + 1 }}
                      </div>
                    </div>

                    <!-- Student List Column -->
                    <div class="table-column">
                      <h3 class="header">Student List</h3>
                      <draggable :list="studentList" :group="{ name: 'people', pull: true, put: true }" :disabled="disableDraggable">
                        <transition-group name="fade" tag="div">
                          <div
                          v-for="(element) in studentList"
                          :key="element.name"
                          :class="['vuedraggable--dragging', 'table-cell', {'force-default-cursor': disableDraggable}]"
                          >

                            <v-chip style="margin-top: 5px;" variant="flat" color="primary" v-if="element.feeDetails.some(i => i.flag === 'amber')">
                                <span>{{ element.name }} - {{element.destinationName}}</span>
                            </v-chip>
                            <v-chip style="margin-top: 5px;" variant="flat" color="red" v-else-if="element.feeDetails.some(i => i.flag === 'red')">
                              <span>{{ element.name }} - {{element.destinationName}}</span>
                            </v-chip>
                              <span v-else>{{ element.name }} - {{element.destinationName}}</span>
                            </div>
                            <div v-for="i in (maxCapacity - studentList.length)" :key="i" class="table-cell"></div>
                          </transition-group>
                        </draggable>
                      <!-- Fill remaining rows with empty cells -->

                    </div>

                    <!-- Dynamic Stop Columns -->

                    <div v-for="stop in visibleVehicles" :key="stop.id" class="table-column">
                      <h3 class="header">{{ stop.text }}</h3>
                        <draggable
                          :list="stop.studentList"
                          :group="{ name: stop.colIdentity, put: ['people', stop.colIdentity] }"
                          :move="checkMove"
                          :disabled="disableDraggable"
                          @change="(e) => handleDrop(e, stop)"
                        >
                          <transition-group name="move" tag="div">
                            <div
                              v-for="(element, index) in stop.studentList"
                              :key="element.name"
                              @mouseenter="handleMouseEnter($event, element)"
                              @mouseleave="handleMouseLeave"
                              :class="['vuedraggable--dragging', 'table-cell', {'force-default-cursor': disableDraggable}]"
                              >

                              <span class="seat-label">S{{ index + 1 }}</span>

                              <v-chip style="margin-top: 5px;" variant="flat" color="primary" v-if="element.feeDetails.some(i => i.flag === 'amber')">
                                <span :class="{ 'bold-text': element.isTemporaryRouteAssigned }">{{ element.name }}</span>
                              </v-chip>
                              <v-chip style="margin-top: 5px;" variant="flat" color="red" v-else-if="element.feeDetails.some(i => i.flag === 'red')">
                                <span :class="{ 'bold-text': element.isTemporaryRouteAssigned }">{{ element.name }}</span>
                              </v-chip>
                                <span v-else :class="{ 'bold-text': element.isTemporaryRouteAssigned }">{{ element.name }}</span>
                            </div>
                            <div
                              v-if="showTooltip && hoveredStudent?.isTemporaryRouteAssigned"
                              class="custom-tooltip"
                              :key="'tooltip-'+(hoveredStudent?.id || hoveredStudent?.name || 'unknown')"
                              :style="{ top: tooltipPosition.top + 'px', left: tooltipPosition.left + 'px' }"
                            >
                              <div><strong>Permanent Vehicle No:</strong> {{ hoveredStudent.oldRouteDetails.vehicleNo }}</div>
                              <div><strong>Route Name:</strong> {{ hoveredStudent.oldRouteDetails.destination }}</div>
                              <div><strong>Route Type:</strong> {{ hoveredStudent.oldRouteDetails.journeyType }}</div>
                            </div>
                            <div
                              v-for="element in Array.from({ length: stop.seatingCapacity - stop.studentList.length }, (_, i) => stop.studentList.length + i + 1)"
                              :key="`emtpy-seat-${element}`"
                              class="table-cell"
                            >
                              <span class="seat-label">S{{ element }}</span>
                            </div>
                          </transition-group>
                        </draggable>

                      <div
                        v-for="element in Array.from({ length: maxCapacity - stop.seatingCapacity }, (_, i) => stop.studentList.length + i + 1)"
                        :key="`no-seat-element-${element}`"
                        class="table-cell empty-cell tablebodyview"
                      >
                        <span class="seat-label"></span>
                      </div>
                    </div>

                    <div class="table-column extra-column" v-if="glimpseVehicle.length">
                      <h3 class="header">{{glimpseVehicle[0].text.slice(0, 6) + "..."}}</h3>
                      <div v-for="n in maxCapacity" :key="`extra-${n}`" class="table-cell"></div>
                    </div>

                  </div>
                  <div class="grid-table" v-if="!maxCapacity">
                    <div class="table-column">
                      <div
                        class="table-cell"
                      >
                        1
                      </div>
                    </div>
                    <div class="table-column">
                      <div
                        class="table-cell"
                      >
                        No data to show
                      </div>
                    </div>
                  </div>
                </div>

              </template>

              <div style="margin-top:20px"></div>
              <!-- <v-btn color="primary" @click="step = 1">Go to Step 1</v-btn> -->
              <v-container  class="tablecontainerpadd" v-if="studentLogsDetails.length>0">
                <v-card>
                    <v-data-table
                    :headers="loginHeaders"
                    :items="studentLogsDetails"
                    item-key="id"
                    class="elevation-1"
                    :items-per-page="5"
                    :page.sync="page"
                    :server-items-length="totalLogs"
                    :loading="isLoading"
                    @update:options="onTableOptionsChanged"
                    >
                    <template v-slot:item="{ item }">
                    <!-- {{item}} -->
                        <tr>
                            <td>{{ formatDate(item.updatedAt) }}</td>
                            <td>{{ formatTime(item.updatedAt) }}</td>
                            <td>{{ item.createdBy }}</td>
                            <td>
                              <router-link   v-if="item.oldData"  :to="{ name: 'StudentDestinationLogDetails', params: { item }, query: { dataID:item.id, logType: 'old', journeyType: journeyType ? journeyType : '' } }">
                                Version
                              </router-link>
                               <span v-else class="router-link-disabled">
                                -
                              </span>
                            </td>
                            <td>
                              <router-link   v-if="item.newData"  :to="{ name: 'StudentDestinationLogDetails', params: { item }, query: { dataID:item.id, logType: 'new', journeyType: journeyType ? journeyType : '' } }">
                                Version
                              </router-link>
                              <span v-else class="router-link-disabled">
                                -
                              </span>
                            </td>
                            <td>{{ item.platform }}</td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-card>
              </v-container>

            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>

<script>
// import VCardComponent from '@/components/template/VCardComponent'
// import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
// import { ref } from 'vue'
// const selected = ref([])
import draggable from 'vuedraggable'
import ExportUtility from '@/utils/exportUtility'
import stores from '@/stores'

export default {
  name: 'StudentDestinationMap',
  components: {
    // MaterialCard
    //  VCardComponent
    draggable
  },
  beforeRouteEnter (to, from, next) {
    if (from.path === '/transport/stundent-Destination-Log-Details') {
      next(vm => {
        vm.handleNavigationFromLogPage(from.query ? from.query.journeyType : '')
      })
    } else {
      next()
    }
  },
  data () {
    return {
      franchiseeID: null,
      academicYearID: null,
      isLoading: false,
      inProgress: false,
      step: 1,
      assignedFilter: null,
      journeyType: null,
      journeyTypeName: null,
      journeyTypes: ['Only Pickup', 'Only Drop', 'Pick Up & Drop'],
      destinations: [],
      maxSeatingCapacity: 0,
      numberOfStudentsAvailedForTransport: 0,
      routeAssignedTo: 0,
      total: 0,
      selected: [],
      searchKey: '',
      searching: false,
      globalCTA: false,
      headersStep1: [
        { text: 'Sr. No.', value: 'srNo', sortable: false },
        { text: 'Student Name', value: 'studentName', sortable: false },
        { text: 'Journey Type', value: 'journeyType', sortable: false },
        { text: 'Vehicle Route', value: 'vehicleRoute', sortable: false },
        { text: 'Action', value: 'assign', sortable: false }
      ],
      studentsStep1: [],
      studentsStep1Filtered: [],
      studentDestinationFormData: [],
      vehicleAssigneToCount: 0,
      routeAssignedStudentCount: 0,
      tableHeaders: [],
      studentList: [],
      disableDraggable: true,
      loginHeaders: [
        { text: 'Date', value: 'updatedAt', sortable: false },
        { text: 'Time', value: 'time', sortable: false },
        { text: 'Updated By', value: 'createdBy', sortable: false },
        { text: 'Old Data', value: 'oldData.id', sortable: false },
        { text: 'New Data', value: 'newData.id', sortable: false },
        { text: 'Platform', value: 'platform', sortable: false }
      ],
      studentDestinationLogList: [],
      orignalDataCopy: null,
      studentLogsDetails: [],
      startIndex: 0,
      columnsToShow: this.tableHeaders && this.tableHeaders.length < 4 ? this.tableHeaders.length : 3,
      visibleColumns: 4,
      currentFirstColumn: 0,
      studentsWithoutSeat: 0,
      studentInstallment: '',
      showTooltip: false,
      tooltipPosition: { top: 0, left: 0 },
      hoveredStudent: null,
      totalLogs: 0,
      page: 1,
      itemsPerPage: 5,
      isCurrentAcademicYearSelected: true
    }
  },
  async created () {
    if (this.franchisee.id) {
      this.franchiseeID = this.franchisee.id
    }
  },
  mounted: async function () {
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.onFranchiseeChange()
      }
    },
    academicYear: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.onAcademicYearChange()
      }
    },
    journeyType: function () {
      if (this.journeyType === 'Only Pickup') {
        this.journeyTypeName = 'PickUp'
      }
      if (this.journeyType === 'Only Drop') {
        this.journeyTypeName = 'Drop'
      }
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),
    visibleHeaders () {
      return this.tableHeaders.slice(this.startIndex, this.startIndex + this.columnsToShow)
    },
    isAtStart () {
      return this.startIndex === 0
    },
    isAtEnd () {
      return this.startIndex + this.columnsToShow >= this.tableHeaders.length
    },
    maxCapacity () {
      return Math.max(this.studentList.length, ...this.tableHeaders.map(v => v.seatingCapacity))
    },
    visibleVehicles () {
      return this.tableHeaders.slice(this.currentFirstColumn, this.currentFirstColumn + this.visibleColumns)
    },
    glimpseVehicle () {
      return this.tableHeaders.slice(this.currentFirstColumn + this.visibleColumns, this.currentFirstColumn + this.visibleColumns + 1)
    }
  },
  methods: {
    handleNavigationFromLogPage (journeyType) {
      if (journeyType) {
        this.journeyType = journeyType
        this.getVendorLogsDetails()
      }
      this.step = 2
    },
    assignRouteDisableBtn () {
      let shouldDisable = false

      if (this.studentsStep1.length === 0 && this.studentsStep1Filtered.length === 0) {
        shouldDisable = true
      }
      if (this.searching && this.studentsStep1Filtered.length === 0) {
        shouldDisable = true
      }

      return shouldDisable
    },
    slideLeft () {
      if (this.currentFirstColumn > 0) {
        this.currentFirstColumn -= 1
      }
    },
    slideRight () {
      if (this.currentFirstColumn + this.visibleColumns < this.tableHeaders.length) {
        this.currentFirstColumn += 1
      }
    },
    checkMove (evt) {
    },
    handleDrop (evt, stop) {
      if (stop.studentList.length > stop.seatingCapacity) {
        // const oldIndex = evt.oldIndex
        // const newIndex = evt.newIndex
        let replacedSeat = stop.studentList.pop()
        this.studentList.push(replacedSeat)
      }
    },
    nextColumns () {
      if (this.startIndex + this.columnsToShow < this.tableHeaders.length) {
        this.startIndex++
      }
    },
    prevColumns () {
      if (this.startIndex > 0) {
        this.startIndex--
      }
    },
    nodeIndex (event) {
      const { added, removed } = event

      if (removed) {
        const removedItem = removed.element
        removedItem.action = 'remove'
      }
      if (added) {
        const addedItem = added.element
        addedItem.action = 'add'
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee && this.franchisee.id) {
          this.franchiseeID = this.franchisee.id
        } else {
          let getFranchiseeData = this.getFranchiseeDataFromIndexDB()
          this.franchiseeID = (getFranchiseeData && getFranchiseeData.id) ? getFranchiseeData.id : ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
          this.getCurrentYearValidation(false)
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
        await this.getStudentListing()
        await this.getDestinations()
        if (this.journeyType && this.step === 2) { this.getStudentVehicleMappings(this.journeyType) }
      }
    },
    getFranchiseeDataFromIndexDB: function () {
      let obj = stores.user.franchisee
      return obj
    },
    onAcademicYearChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
          this.getCurrentYearValidation()
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    validateForm () {
      if (!this.selected.length) {
        return false
      }
      let selectedRows = this.selected.map(i => i.studentAdmissionID)
      let selected = this.studentDestinationFormData.filter(item => selectedRows.includes(item.studentAdmissionID))
      return selected.every(item => item.journeyType && item.destinationID)
    },
    addSelection (select) {
      select(true)
    },
    clearFilters () {
      this.assignedFilter = null
      this.searching = false
      this.searchKey = ''
    },
    async editRoute (select, index, currentData) {
      let item = this.studentDestinationFormData[index]
      if (!item.journeyType || !item.destinationID) {
        this.$dialog.message.info('All fields are required', {
          position: 'bottom-right',
          color: 'secondary',
          timeout: 4000
        })
        return
      }
      let payload = [
        {
          studentAdmissionID: item.studentAdmissionID,
          journeyType: item.journeyType,
          destinationID: item.destinationID
        }
      ]
      try {
        // if(!currentData.transportStudentVehicleMapping)
        const { data } = await http.post(`${constants.API_URL}/api/transport/students/${this.franchiseeID}/destination-map`, payload)
        this.$dialog.message.error(data.message, {
          position: 'bottom-right',
          color: 'green',
          timeout: 4000
        })
        select(false)
        this.getStudentListing()
        this.getStudentVehicleMappings(this.journeyType)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.$dialog.message.error(errorMessage, {
          position: 'bottom-right',
          color: 'red',
          timeout: 4000
        })
      }
    },
    removeSelection (select, index, item) {
      let previosJourneyType = item.transportStudentVehicleMapping && item.transportStudentVehicleMapping.journeyType ? item.transportStudentVehicleMapping.journeyType : null

      let previousDestinationID = item.transportStudentVehicleMapping && item.transportStudentVehicleMapping.destinationID ? item.transportStudentVehicleMapping.destinationID : null

      this.studentDestinationFormData[index].journeyType = previosJourneyType
      this.studentDestinationFormData[index].destinationID = previousDestinationID

      select(false)
    },
    downloadListData (state) {
      this.getStudentVehicleMappings(this.journeyType, 1)
    },
    ExportXl (tableHeaders) {
      const csvData = []
      const maxSeatingCapacity = Math.max(...tableHeaders.map(stop => stop.studentList.length))

      for (let i = 0; i < maxSeatingCapacity; i++) {
        const row = {}
        row['Sr. No.'] = i + 1
        tableHeaders.forEach(stop => {
          row[`${stop.text}`] = stop.studentList[i] ? stop.studentList[i].name : ''
        })
        csvData.push(row)
      }

      ExportUtility.convertToCsv(csvData, 'vehicle_student_mappings_' + this.franchiseeID)
    },
    emptySelection () {
      let selectedRows = this.selected.map(i => i.studentAdmissionID)
      let selected = this.studentDestinationFormData.filter(item => selectedRows.includes(item.studentAdmissionID))
      if (selected.some(item => item.journeyType || item.destinationID)) {
        this.$dialog.warning({
          title: 'All the entered data will be lost.',
          text: 'Are you sure you want to cancel the process?',
          actions: {
            false: {
              text: 'Not Now'
            },
            true: {
              color: 'success',
              text: 'Proceed Cancellation',
              handle: () => {
                this.selected = []
                this.globalCTA = false
                this.clearFormData()
              }
            }
          }
        })
      } else {
        this.selected = []
        this.globalCTA = false
        this.clearFormData()
      }
    },
    clearAllFormData () {
      this.studentDestinationFormData = this.studentDestinationFormData.map(student => ({ ...student, journeyType: student.journeyType ? student.journeyType : null, destinationID: student.destinationID ? student.destinationID : null }))
    },
    clearFormData () {
      this.studentsStep1.forEach((item, index) => {
        if (item.transportStudentVehicleMapping && !item.transportStudentVehicleMapping.journeyType) {
          this.studentDestinationFormData[index].journeyType = null
        }
        if (item.transportStudentVehicleMapping && !item.transportStudentVehicleMapping.destinationID) {
          this.studentDestinationFormData[index].destinationID = null
        }
      })
    },
    assignRouteToAll (source) {
      if (source === 'headerCheckbox') {
        if (this.globalCTA) {
          this.globalCTA = false
          this.selected = []
          return
        }
      }
      this.globalCTA = true
      if (this.searching) {
        this.selected = this.studentsStep1Filtered.filter(item => !item.transportStudentVehicleMapping || (item.transportStudentVehicleMapping && !item.transportStudentVehicleMapping.journeyType && !item.transportStudentVehicleMapping.destinationID))
      } else {
        this.selected = this.studentsStep1.filter(item => !item.transportStudentVehicleMapping || (item.transportStudentVehicleMapping && !item.transportStudentVehicleMapping.journeyType && !item.transportStudentVehicleMapping.destinationID))
      }
    },
    async assigneRouteGlobal () {
      let selectedIDs = this.selected.map(i => i.studentAdmissionID)
      let payload = this.studentDestinationFormData
        .filter(i => selectedIDs.includes(i.studentAdmissionID))
        .map(i => ({ studentAdmissionID: i.studentAdmissionID, journeyType: i.journeyType, destinationID: i.destinationID }))

      try {
        // if(!currentData.transportStudentVehicleMapping)
        const { data } = await http.post(`${constants.API_URL}/api/transport/students/${this.franchiseeID}/destination-map`, payload)
        this.$dialog.message.error(data.message, {
          position: 'bottom-right',
          color: 'green',
          timeout: 4000
        })
        this.selected = []
        this.globalCTA = false
        this.getStudentListing()
        this.getStudentVehicleMappings(this.journeyType)
        this.step = 2
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.$dialog.message.error(errorMessage, {
          position: 'bottom-right',
          color: 'red',
          timeout: 4000
        })
      }
    },
    applyJourneyType () {
      this.getStudentVehicleMappings(this.journeyType)
      if (this.journeyType) {
        this.getVendorLogsDetails()
      }
    },
    toggle (isSelected, select, index) {
      select(!isSelected)
    },
    async getDestinations () {
      if (this.franchiseeID) {
        try {
          const { data } = await http.get(`${constants.API_URL}/api/transport/destinations?key=vehicle-mapped-destinations&franchiseeID=${this.franchiseeID}`)
          this.destinations = data
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          this.lock = false
          this.hasClicked = false
          return this.$buefy.dialog.alert({
            message: errorMessage,
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      }
    },
    async getStudentListing () {
      this.studentsStep1 = []
      this.studentsStep1Filtered = []
      this.numberOfStudentsAvailedForTransport = 0
      this.routeAssignedTo = 0
      // this.clearFilters()
      this.total = 0
      try {
        let getParam = {}
        if (!this.franchiseeID) {
          this.$buefy.toast.open({
            message: 'Please select franchisee',
            type: 'is-danger',
            duration: 4000
          })
          return
        }
        if (!this.academicYearID) {
          return
        }
        getParam.franchiseeID = this.franchiseeID
        getParam.academicYearID = this.academicYearID
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/students/destination-map`, {
          params: getParam
        })
        this.studentsStep1 = data.rows.map((d, index) => ({ ...d, srNo: index + 1 }))
        this.total = data.count
        this.numberOfStudentsAvailedForTransport = data.count
        this.routeAssignedTo = data.routeAssignedStudentCount
        this.studentDestinationFormData = this.studentsStep1.map((item, index) => ({
          srNo: index,
          studentAdmissionID: item.studentAdmissionID,
          journeyType: item.transportStudentVehicleMapping ? item.transportStudentVehicleMapping.journeyType : null,
          destinationID: item.transportStudentVehicleMapping && item.transportStudentVehicleMapping.transportDestination ? item.transportStudentVehicleMapping.transportDestination.destinationID : null
        }))
        if (this.searching || this.searchKey) {
          this.filterStudents()
        }

        const today = new Date()

        for (const item of data.feeInstallmentsRows) {
          const sortedInstallments = item.studentEnrollment.enquiry.assignFeeInstallments
            .filter(trans => {
              return trans.feeTypeName === 'Transport Fees'
            })

          if (sortedInstallments.length === 1) {
            // check yearly plan

            const dueDate = new Date(sortedInstallments[0].dueDate)
            const timeDiff = dueDate.getTime() - today.getTime()
            const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))

            if (dayDiff === 0 || dayDiff < 0) {
              sortedInstallments[0].flag = 'red'
            } else if (dayDiff <= 15 && dayDiff > 0) {
              sortedInstallments[0].flag = 'amber'
            }
          }
          for (const item1 of this.studentsStep1) {
            if (item.studentEnrollment.enquiry.id === item1.studentEnrollment.enquiry.id) {
              this.$set(item1, 'studentnewInstallment', sortedInstallments)
            }
          }
        }

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
      } finally {
        this.isLoading = false
      }
    },
    async getCurrentYearValidation (skipGetStudentListing = true) {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears-by-id?academicYearID=${this.academicYearID}`)
        let academicYears = data
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        if (!academicYear) {
          this.isCurrentAcademicYearSelected = false
          if (skipGetStudentListing) {
            this.getStudentListing()
          }
          this.studentsStep1Filtered = []
          this.clearFilters()
          this.step = 1
          return
        } else {
          this.isCurrentAcademicYearSelected = true
          if (skipGetStudentListing) {
            this.getStudentListing()
          }
          this.studentsStep1Filtered = []
          this.clearFilters()
          this.step = 1
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    filterStudents () {
      if (this.searchKey || this.searching) {
        this.searching = true
        this.studentsStep1Filtered = this.studentsStep1.filter(item =>
          item.studentEnrollment.name.toLowerCase().includes(this.searchKey.toLowerCase()) &&
          (
            !this.assignedFilter ||
            (this.assignedFilter === 'assigned' && item.transportStudentVehicleMapping && item.transportStudentVehicleMapping.journeyType && item.transportStudentVehicleMapping.destinationID) ||
            (this.assignedFilter === 'unassigned' && (!item.transportStudentVehicleMapping || (item.transportStudentVehicleMapping && (!item.transportStudentVehicleMapping.journeyType || !item.transportStudentVehicleMapping.destinationID))))
          )
        )
      } else {
        this.searching = false
        this.studentsStep1Filtered = []
      }
    },
    filterStudentsByAssigned () {
      if (this.assignedFilter === 'assigned') {
        this.studentsStep1Filtered = this.studentsStep1.filter(item => item.transportStudentVehicleMapping && item.transportStudentVehicleMapping.journeyType && item.transportStudentVehicleMapping.destinationID)
      } else if (this.assignedFilter === 'unassigned') {
        this.studentsStep1Filtered = this.studentsStep1.filter(item => !item.transportStudentVehicleMapping || (item.transportStudentVehicleMapping && (!item.transportStudentVehicleMapping.journeyType || !item.transportStudentVehicleMapping.destinationID)))
      }
      this.searching = true
    },
    gotToStep () {
      this.step = this.step === 1 ? 2 : 1
      if (this.step === 1) {
        this.getStudentListing()
      } else {
        if (this.journeyType) {
          this.getStudentVehicleMappings(this.journeyType)
          this.getVendorLogsDetails()
        }
      }
    },
    async getStudentVehicleMappings (journeyType, exportFlag) {
      if (!journeyType && this.step === 2) {
        this.$dialog.message.info('Please select journey type!', {
          position: 'bottom-right',
          color: 'secondary',
          timeout: 4000
        })
        return
      }
      if (this.step === 1) {
        return
      }
      this.disableDraggable = true
      try {
        let getParam = {}
        if (!(this.franchiseeID && this.academicYearID)) {
          this.isLoading = false
          return
        }
        getParam.franchiseeID = this.franchiseeID
        getParam.academicYearID = this.academicYearID
        getParam.journeyType = journeyType
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/transport/students/vehicle-map`, {
          params: getParam
        })
        this.isLoading = false

        if (exportFlag && exportFlag === 1) {
          this.ExportXl(data.rows)
        } else {
          this.studentList = data.parkedStudentList
          this.tableHeaders = data.rows
          this.vehicleAssigneToCount = data.vehicleAssigneToCount
          this.routeAssignedStudentCount = data.routeAssignedStudentCount
          this.studentsWithoutSeat = data.studentsWithoutSeat
          this.maxSeatingCapacity = Math.max(data.maxSeatingCapacity, this.studentList.length)
          this.orignalDataCopy = JSON.parse(JSON.stringify(data))

          const today = new Date()

          // student list
          for (const item of this.studentList) {
            const studPlan = item.feeDetails.filter(trans => {
              return trans.feeTypeName === 'Transport Fees'
            })

            if (studPlan.length === 1) {
              // check yearly plan

              const dueDate = new Date(studPlan[0].dueDate)
              const timeDiff = dueDate.getTime() - today.getTime()
              const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))

              if (dayDiff === 0 || dayDiff < 0) {
                studPlan[0].flag = 'red'
              } else if (dayDiff <= 15 && dayDiff > 0) {
                studPlan[0].flag = 'amber'
              }
            }
          }
          // dragable student
          for (const item of this.tableHeaders) {
            for (const sitem of item.studentList) {
              const sortedInstallments = sitem.feeDetails
                .filter(trans => {
                  return trans.feeTypeName === 'Transport Fees'
                })

              if (sortedInstallments.length === 1) {
                // check yearly plan

                const dueDate = new Date(sortedInstallments[0].dueDate)
                const timeDiff = dueDate.getTime() - today.getTime()
                const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))

                if (dayDiff === 0 || dayDiff < 0) {
                  sortedInstallments[0].flag = 'red'
                } else if (dayDiff <= 15 && dayDiff > 0) {
                  sortedInstallments[0].flag = 'amber'
                }
              }
            }
          }
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.message.error(errorMessage, {
          position: 'bottom-right',
          color: 'red',
          timeout: 4000
        })
      }
    },
    formatDate (createdDate) {
      const date = new Date(createdDate)
      return date.toLocaleDateString()
    },
    formatTime (createdTime) {
      const time = new Date(createdTime)
      return time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })
    },
    getVendorLogsDetails: async function () {
      try {
        this.isLoading = true
        const response = await http.get(
          `${constants.API_URL}/api/transport/vendors/${this.franchiseeID}/logs`,
          {
            params: {
              journeyType: this.journeyType,
              logType: 'STUDENT_VEHICLE_MAPPINGS',
              limit: this.itemsPerPage,
              offset: (this.page - 1) * this.itemsPerPage
            }
          }
        )
        this.studentLogsDetails = response.data.logs || []
        this.totalLogs = response.data.total || 0
        this.isLoading = false
      } catch (e) {
        this.studentLogsDetails = []
        this.page = 1
        this.itemsPerPage = 5
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.snackbar.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 5000,
          position: 'is-bottom-right',
          actionText: 'Close'
        })
      }
    },
    async saveStudentSeatArrangements () {
      let oldParkingData = this.orignalDataCopy.parkedStudentList.map(orig => {
        let existsInNew = this.studentList.some(newItem => newItem.id === orig.id)
        if (!existsInNew) {
          return { ...orig, action: 'remove' }
        }
        return { ...orig, action: null }
      })

      let oldRowData = this.orignalDataCopy.rows.map(row => {
        let matchingNewRow = this.tableHeaders.find(newRow => newRow.id === row.id)
        let updatedStudentList = row.studentList.map(student => {
          let existsInNew = matchingNewRow && matchingNewRow.studentList.some(newStudent => newStudent.id === student.id)
          return existsInNew ? { ...student, action: null } : { ...student, action: 'remove' }
        })
        return { ...row, studentList: updatedStudentList }
      })

      let newParkingData = this.studentList.map(newItem => {
        let existsInOriginal = this.orignalDataCopy.parkedStudentList.some(orig => orig.id === newItem.id)
        if (!existsInOriginal) {
          return { ...newItem, action: 'add' }
        }
        return { ...newItem, action: null }
      })

      let newRowData = this.tableHeaders.map(row => {
        let matchingOriginalRow = this.orignalDataCopy.rows.find(originalRow => originalRow.id === row.id)
        let updatedStudentList = row.studentList.map(student => {
          let existsInOriginal = matchingOriginalRow && matchingOriginalRow.studentList.some(origStudent => origStudent.id === student.id)
          return existsInOriginal ? { ...student, action: null } : { ...student, action: 'add' }
        })
        return { ...row, studentList: updatedStudentList }
      })

      let oldData = {
        routeAssignedStudentCount: this.routeAssignedStudentCount,
        vehicleAssigneToCount: this.vehicleAssigneToCount,
        parkedStudentList: oldParkingData,
        rows: oldRowData,
        maxSeatingCapacity: this.maxSeatingCapacity
      }

      let newData = {
        routeAssignedStudentCount: this.routeAssignedStudentCount,
        vehicleAssigneToCount: this.vehicleAssigneToCount,
        parkedStudentList: newParkingData,
        rows: newRowData,
        maxSeatingCapacity: this.maxSeatingCapacity
      }

      let studentSeats = []
      for (let bus of this.tableHeaders) {
        studentSeats = studentSeats.concat(bus.studentList.map((student, seatNumber) => ({
          studentAdmissionID: student.id,
          destinationID: bus.destinationID,
          busID: bus.id,
          seatNumber: seatNumber + 1
        })))
      }

      try {
        let getParam = {}
        // if(!currentData.transportStudentVehicleMapping)
        if (this.franchiseeID) {
          getParam.franchiseeID = this.franchiseeID
        }
        if (this.academicYearID) {
          getParam.academicYearID = this.academicYearID
        }
        await http.put(`${constants.API_URL}/api/transport/students/vehicle-map/re-arrange-seats`,
          {
            journeyType: this.journeyType,
            parkedStudentList: this.studentList.map(s => s.id),
            studentSeats,
            oldData,
            newData
          },
          {
            params: getParam
          }
        )
        this.disableDraggable = false
        this.$dialog.message.error('Seats re-arranged successfully', {
          position: 'bottom-right',
          color: 'green',
          timeout: 4000
        })
        this.getVendorLogsDetails()
        this.getStudentVehicleMappings(this.journeyType)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.$dialog.message.error(errorMessage, {
          position: 'bottom-right',
          color: 'red',
          timeout: 4000
        })
      }
    },
    handleMouseEnter (event, student) {
      if (student.isTemporaryRouteAssigned) {
        const rect = event.target.getBoundingClientRect()
        this.tooltipPosition = {
          top: rect.top + window.scrollY - 100,
          left: rect.left + window.scrollX + 100
        }
        this.hoveredStudent = student
        this.showTooltip = true
      }
    },
    handleMouseLeave () {
      this.showTooltip = false
      this.hoveredStudent = null
    },
    onTableOptionsChanged (options) {
      this.page = options.page
      this.itemsPerPage = options.itemsPerPage
      this.getVendorLogsDetails()
    }
  }
}
</script>
<style scoped>
.alloctionstopdrag {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

}
.alloctionstopdrag .col-2.border2{
  padding: 0px;
}
.alloctionstopdragrow{
    display: flex;
    overflow-x: hidden;
    flex-wrap: initial;
    padding: 15px 0px;
}
.alloctionstopdragview .list-group .list-group-item, .alloctionstopdragview .list-group-item{
    font-size: 13px;
    color: #424242;
    letter-spacing: 0.3px;
    text-transform: capitalize;
    cursor: pointer;

}
.alloctionstopdragrow .alloctionstopdragview:first-child{
  background: #E3F2FD;
}
.alloctionstopdragrow .alloctionstopdragview:last-child{
  background: #E3F2FD;
  border-right: 1px solid #e0e0e0!important;
}
.alloctionstopdragview h3{
  text-align: center;
  margin: 0;
  padding: 10px;
  background-color: #f4f4f4;
  border-bottom: 1px solid #000; /* Separate the header from the content */
}
.alloctionstopdragview .list-group .list-group-item:hover{
  color: black;
    font-weight: 400;
}

.stopallocationviewcolor .v-btn__content{
  color: #fff;
}

.border2 {
  border: 0.5px solid #000; /* Add border around each cell */
}

.list-group {
  padding: 0;
  list-style-type: none;
  margin: 0;
}

.list-group-item {
  padding: 10px;
  border: 0.5px solid #000; /* Add border between items */
}

.addSpace{
  marginTop : 50px;
}

.new-row {
  height:50px;
  display: flex;
  overflow-x: hidden;
  width: 100%;
  flex-wrap: nowrap;

}

.disabled-button .icon {
  color: lightgrey;
}

.active-button .icon {
  color: black; /* or any color you prefer */
}

.flext-container {
  display: flex;
  flex-direction: column
}

.arrow-row {
  display: flex;
}

.arrow {
  text-align: center;
  font-size: 1.5rem;
  cursor: pointer;
  user-select: none;
  transition: transform 0.3s;
}

.arrow.disabled {
  cursor: not-allowed;
  opacity: 0.8;
}

.arrow:hover:not(.disabled) {
  transform: scale(1.2);
}

.slide-enter-active, .slide-leave-active {
  transition: all 0.5s ease;
}

.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}

.arrow:hover {
  transform: scale(1.2);
}

.left-arrow {
  grid-column: 3 / 4;
}

.right-arrow {
  grid-column: span 1;
}

.grid-table {
  display: grid;
  grid-template-columns: 80px repeat(5, 1fr) 100px; /* Dynamic columns */
  gap: 0; /* Ensure no gaps between columns */
  width: 100%;
  border-collapse: collapse; /* Collapse all borders */
}

.table-column {
  display: flex;
  flex-direction: column;
  border: 0.3px solid #0000005e; /* Full column border */
  transition: transform 0.3s ease;
}

.extra-column {
  border: none;
  color: black;
  opacity: 0.4;
  border: 0.3px solid #0000005e;

}
.marginauto {
  margin-left: auto
}
.table-cell, .header {
  padding: 10px;
  text-align: center;
  border: 0.3px solid #0000005e; /* Individual cell border */
  background-color: white;
  position: relative; /* Enable absolute positioning for seat-label */
    transition: background-color 0.3s, transform 0.3s ease; /* Smooth transition when item moves */

}

.vuedraggable--dragging:hover {
  cursor: grabbing;
}

.table-cell.empty-cell {
  background-color: #f0f0f0; /* Grey background for empty cells */
    transition: background-color 0.3s;

}

h3.header {
  text-align: center;
  border-bottom: 0.3px solid #0000005e;
  margin: 0;
}

.seat-label {
  position: absolute;
  top: 5px;
  right: 5px;
  font-weight: 400;
  font-size: 14px
}

.table-cell {
  height: 70px; /* Ensures consistent row height */
}

.vuedraggable--dragging .table-cell {
  cursor: grabbing;
  opacity: 0.8; /* Make it visually distinct when dragging */
  transform: scale(1.05); /* Slightly enlarge while dragging */
  transition: transform 0.2s ease-in-out, opacity 0.2s; /* Animation for dragging */

}

/* Animation for moving items */
.move {
  transition: transform 0.5s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.radiobuttons{
  margin-top: 0px;
}
.radiobuttons .v-input--radio-group__input{
  display: flex;
    flex-direction: unset!important;
}
.elevation-1 th .v-icon.notranslate{
  color: #fff!important;
}
.routemappingshadow{
  box-shadow: none !important;

}
.containerviewall{
  padding: 15px 5px;
}
.routemappingheader{
  box-shadow: none !important;
  border-bottom: 1px solid #ccc;
  padding: 0px 10px!important;

}
.routemappingcontainer{
  padding: 10px 5px!important;
}
.tablecontainerpadd{
  padding: 0px;
    margin: 0px;
    max-width: 100%;
}
.tableheaderbg .table-column{
  background: #5d58ef;
  border: 1px solid #ccc;
  border-bottom: none!important;
}
.tablebodyview .table-column{
  border: 0px solid #ccc !important;
  box-shadow: none !important;
}
.arrow-row .arrow{
    font-size: 14px;
    padding: 10px;
    margin: 0px auto;
    color: #fff;
}
/* .tablebodyview .seat-label{
  position: unset;
} */
.grid-table.tablebodyview .table-column {
  background: #ddd;
  border: 1px solid #ccc;
  border-bottom: none!important;

}
.grid-table.tablebodyview .table-column h3.header{
  background: unset;
}
.text-red{
  color: #cd0000;
}
</style>
<style scoped>
.force-default-cursor {
  cursor: default !important;
}
.custom-tooltip {
  position: absolute;
  z-index: 1000;
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  font-size: 14px;
  max-width: 250px;
  pointer-events: none;
}
.bold-text {
  font-weight: bold;
}

</style>
